var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReuse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4a2 2 0 00-2 2v18a2 2 0 002 2h8a2 2 0 002-2V6a2 2 0 00-2-2h-8zM5 6a2 2 0 00-2 2v14a2 2 0 002 2h2V6H5zm18 0v18h2a2 2 0 002-2V8a2 2 0 00-2-2h-2z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMCAzMCI+CiAgPHBhdGggZD0iTTExIDRhMiAyIDAgMCAwLTIgMnYxOGEyIDIgMCAwIDAgMiAyaDhhMiAyIDAgMCAwIDItMlY2YTIgMiAwIDAgMC0yLTJoLTh6TTUgNmEyIDIgMCAwIDAtMiAydjE0YTIgMiAwIDAgMCAyIDJoMlY2SDV6bTE4IDB2MThoMmEyIDIgMCAwIDAgMi0yVjhhMiAyIDAgMCAwLTItMmgtMnoiLz4KPC9zdmc+Cg==";
export { SvgReuse as ReactComponent };